import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import LoadingComponent from "../../../../common/LoadingComponent";
import { Button, Header, Modal, Message, Grid } from "semantic-ui-react";

class ShowInitiativeMetaData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      metaData: this.props.metaData,
      loader: false
    };
  }

  componentWillMount() {}

  close = () => {
    this.props.setMetadataSchemaModalFlag(false);
  };
  IsValidJSONString = (e, data) => {
    try {
      JSON.parse(e.target.value);
    } catch (e) {
      this.setState({ isJSONValid: false });
      return false;
    }
    this.setState({
      isJSONValid: true,
      metaData: JSON.parse(e.target.value),
    });
    return true;
  };
  onSubmitNewTemplate = (data) => {};

  async saveUpdatedMetaData() {
    // Below changes for KLM-9001
    this.setState({loader: true})
    if (this.props.view === "intiative") {
      const payLoad = {
        _id: this.props.selectedInitiative._id,
        metaData: this.state.metaData,
      };
      await dispatch.initiatives.updateInitiativeBySpecificFields(payLoad).then(() => {
        this.props.setMetadataSchemaModalFlag(false);
        this.setState({loader: false})
      })
    } else if (this.props.view === "sequence") {
      let payload = {
        _id: this.props.selectedInitiative._id,
        metaData: this.state.metaData,
      };
      dispatch.initiatives.updateInitiativeActivities(payload).then(() => {
        this.props.setMetadataSchemaModalFlag(false);
        this.setState({loader: false})
      })
    }

    //   let payload = {
    //     id: this.props.selectedInitiative._id,
    //     data: {
    //       metaData: this.state.metaData,
    //     },
    //   };
    //   await dispatch.initiatives.updateInitiative(payload);
    
  }
  render() {
    const errorLabel = <div className="customErrorLabel" />;
    const { metaData } = this.props;

    return (
      <div>
      <LoadingComponent active={this.state.loader} message="Saving Metadata... " />
      <Modal
        open={this.props.open}
        onClose={this.close}
        size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header content={`Manage Metadata `} />
        <Modal.Content>
          <Form
            noValidate
            ref={(ref) => (this.form = ref)}
            className="formcyForm"
            name="cretePack"
            id="cretePackID"
            onValidSubmit={(event) => {
              this.onSubmitNewTemplate(event);
            }}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Form.TextArea
                    required
                    name="rule"
                    label="Metadata"
                    id="Condition"
                    onChange={(e, data) => this.IsValidJSONString(e, data)}
                    value={JSON.stringify(metaData, null, 4)}
                    errorLabel={errorLabel}
                    style={{ minHeight: "300px" }}
                    instantValidation
                  />
                  {!this.state.isJSONValid ? (
                    <Message
                      className="bg-warning"
                      style={{
                        float: "left",
                        padding: "8px",
                        width: "calc(100% - 200px)",
                        textAlign: "center",
                      }}
                      content="Please enter valid JSON"
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="button-cancel"
            id="cancelSchema"
            onClick={this.close}
          >
            Close
          </Button>
          <Button
            className="button-submit"
            id="cancelSchema"
            onClick={() => this.saveUpdatedMetaData(metaData)}
            disabled={!this.state.isJSONValid ? true : false}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }
}

export default ShowInitiativeMetaData;
